import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { OrganisationDataService } from '@services/organisation-data.service';
import { AuthService } from '@auth0/auth0-angular';
import { DOCUMENT } from '@angular/common';
import { environment } from '@environments/environment';
import { AuthenticationService, WebAppUser } from '@services/authentication.service';
import { distinctUntilChanged, filter, finalize, takeUntil } from 'rxjs/operators';
import { combineLatest, Subject } from 'rxjs';
import { GlobalFunctions, defAppName } from '@global/GlobalFunctions';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';

/**
 * Default Class
 */
@Component({
	selector: 'app-default-page',
	templateUrl: './home-default-page.component.html',
	styleUrls: ['./home-default-page.component.scss']
})
export class HomeDefaultPageComponent implements OnInit, OnDestroy {

	/** Page Loaded */
	public loaded: boolean = false;

	/** App Name */
	public sAppName: SafeHtml; // string = defAppName;

	/** Environment Variables */
	public env: any = environment;

	/** Logged on User */
	public thisUser: WebAppUser;

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/**
	 * Default Constructor
	 * @param auth Auth
	 * @param organisationDataService OrganisationData
	 * @param document document
	 * @param authenticationService authenticationService
	 * @param globalFunctions globalFunctions
	 */
	constructor(
		public auth: AuthService,
		public organisationDataService: OrganisationDataService,
		@Inject(DOCUMENT) public document: Document,
		private authenticationService: AuthenticationService,
		private globalFunctions: GlobalFunctions,
		private sanitizer: DomSanitizer,
		private router: Router
	) {
		this.sAppName = this.sanitizeAppName(defAppName);
	}

	/**
	 * sanitizeAppName
	 * @param appName
	 * @returns
	 */
	sanitizeAppName(appName: string): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(appName);
	}

	/**
	 * Page On Initialise Event Handler
	 */
	ngOnInit(): void {

		combineLatest([
			this.authenticationService.currentUser$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
			this.auth.user$.pipe(takeUntil(this.finalise), distinctUntilChanged())
		]).pipe(
			//filter(([currentUser, user]) => !!currentUser && !!user)
			finalize(() => {
				this.loaded = true;
			})
		).subscribe({
			next: ([currentUser, user]) => {
				if (currentUser) {
					this.globalFunctions.displaySpinner(false);
					this.thisUser = currentUser;					

					if (user == null) {
						//router.navigate(['login']);
					}
					// else {
					// 	this.globalFunctions.displaySpinner(true);
					// }
				}
				this.loaded = true;
			},
			error: (error) => { this.globalFunctions.HandleError(error, "Error: this.authenticationService.currentUser$", false) },
			//complete: () => { console.log("this.authenticationService.currentUser$.subscribe: Complete"); }
		})
	}

	/**
	 * On Cahange
	 * @param event
	 */
	onchange(event: any) {
		// console.log(event);
	}

	/**
	* Page On Destroy Event Handler
	*/
	ngOnDestroy(): void {
		try {
			// Unsubscribe from all subscriptions
			this.finalise.next();
			this.finalise.complete();
		}
		catch { }
	}

	/**
	 * Log Out back to original location
	 */
	logout() {
		this.authenticationService.logout(document);
	}

	/**
	 * Log in
	 */
	logIn() {
		this.authenticationService.login();
	}

}
